import Header from "components/Header/Header"
import AppButton from "components/StyledComponents/AppButton"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import classes from "../menu.module.scss"
import MenuListContainer from "../../../../../components/menuListContainer/index"
import {
  getBarMenuPeriodAction,
  getMenuPeriodAction,
  getWineMenuPeriodAction,
  moveFoodItemCategoryAction,
  reorderMenuItemsAction,
  reorderMenuCategoriesAction
} from "redux/marketing/actions"
import { Typography, Grid, InputAdornment } from "@mui/material"
import { useHistory } from "react-router-dom"
import { useTheme } from "@mui/system"
import { marketingActions } from "redux/marketing/slice/user"
import CategoryModal from "./components/CategoryModal"
import MenuNavBar from "components/menuNavBar"
import SubMenuBar from "components/subMenuBar"
import WineListItems from "components/WineListItems"
import BarListItems from "components/BarListItem"
import BarMenuCategoryModal from "./components/BarMenuCategoryModal"
import SpiritsMenuListContainer from "components/spiritsMenuListConatiner"
import {
  getMenuSubCategoryAction,
  getNewSpiritCountAction,
  getSpiritCMSAction
} from "redux/marketing/actions/user"
import SpiritsSubMenuBar from "components/SpiritsSubMenuBar"
import DMVAddMenuItems from "pages/private/DVM_Console/DMV_Menu/AddDMVMenuItems"
import AddMenuItems from "../AddMenuItems"
import DMV_SpiritSummary from "components/DMVSpiritSummary"
import { getDynamicMenuFieldsAction } from "redux/superAdmin/actions"
import { toTitleCase } from "helpers/functions"
import WineCategoryModal from "./components/WineCategoryModal"
import { useDebounce } from "hooks/utils"
import SearchTextField from "components/StyledComponents/SearchTextField"
import SearchIcon from "@mui/icons-material/Search"
import WineBottleListItems from "components/WineBottleListItems"
import MobilePreview from "components/MobilePreview"
import { DragDropContext } from "react-beautiful-dnd"
import MenuDndBoard from "components/MenuDndBoard"
import ReorderCategoriesModal from "components/ReorderCategoriesModal"

const buttonText = {
  CATEGORY: "+ Add Category",
  ITEM: "+ Add Item",
  IMPORT_SPIRITS: "Import Spirits"
}

const menuText = {
  DINNER: "dinner",
  LUNCH: "lunch",
  BRUNCH: "brunch",
  BREAKFAST: "breakfast",
  BARMENU: "bar menu",
  WINEBAR: "wine by glass",
  SPIRITS: "spirits",
  WINEBOTTLE: "wine by bottle",
  SPECIALS: "specials"
}

// Maps our lowercase tab keys to the exact meal_period strings the ordering API
// uses as a model switch. Food meal-periods are omitted — they fall into the
// API's "anything else" → FoodItem case, so linkCategory.item is sent as-is.
const MEAL_PERIOD_API = {
  [menuText.BARMENU]: "Bar Menu",
  [menuText.WINEBAR]: "Wine By Glass",
  [menuText.WINEBOTTLE]: "Wine By Bottle"
}

function EditMenu() {
  const [breadCrumbs, setBreadcrumbs] = useState([])
  const dispatch = useDispatch()
  const theme = useTheme()
  const history = useHistory()
  const [categoryModal, setCategoryModal] = useState(false)
  const [isEdit] = useState(true)
  const [currentCategoryData, setCurrentCategoryData] = useState({})
  const [isEditModal, setIsEditModal] = useState(false)
  const [isEditModalItem, setIsEditModalItem] = useState(false)
  const [menuItemsModal, setMenuItemsModal] = useState(false)
  const { linkCategory } = useSelector((state) => state?.marketing?.menu || {})
  const { menuPeriod, barMenuPeriod, wineMenuPeriod, spiritData, menuSubCategory } = useSelector(
    (state) => state?.marketing?.menu || []
  )
  const { menuCategory, SpiritSubMenu } = useSelector((state) => state.dmv)
  const [searchValue, setSearchValue] = useState("")
  const debouncedSearchTerm = useDebounce(searchValue, 500)
  const [menuItems, setMenuItems] = useState(menuPeriod)
  const [barItems, setBarItems] = useState(barMenuPeriod)
  const [wineItems, setWineItems] = useState(wineMenuPeriod)
  const [spiritItems, setSpiritItems] = useState(spiritData)
  const [openPreviewModal, setOpenPreviewModal] = useState(false)
  const [reorderCategoriesOpen, setReorderCategoriesOpen] = useState(false)

  // --- Masonry-style 2-column packing (DnD-safe) ---------------------------
  // MUI Masonry uses absolute positioning, which reflows every card whenever a
  // card's height changes (i.e. mid-drag) and breaks react-beautiful-dnd drop
  // targets. Instead we keep two real flex columns and greedily assign each
  // category to the currently shortest column (the same balancing Masonry does)
  // so there are no inter-row gaps while staying in normal document flow.
  const COLUMN_COUNT = 2
  const COLUMN_GAP = 16
  const cardRefs = useRef({})
  const [columns, setColumns] = useState([])

  const seedColumns = (items) => {
    const cols = Array.from({ length: COLUMN_COUNT }, () => [])
    ;(items || []).forEach((cat, i) => cols[i % COLUMN_COUNT].push(cat))
    return cols
  }

  // What we actually render. Fall back to a simple alternating split whenever
  // `columns` is stale (data just changed) so we never paint removed categories.
  const flatColumns = columns.flat()
  const columnsMatchData =
    flatColumns.length === (menuItems?.length || 0) &&
    flatColumns.every((cat) => menuItems?.some((m) => m.food_category_id === cat.food_category_id))
  // Keep the saved arrangement but always render the freshest object for each id.
  // After a re-fetch the category ids are unchanged, so `columns` still holds the
  // stale objects — remap them to the latest menuItems so updated contents show.
  const menuItemsById = new Map((menuItems || []).map((c) => [c.food_category_id, c]))
  const displayColumns = columnsMatchData
    ? columns.map((col) => col.map((c) => menuItemsById.get(c.food_category_id) || c))
    : seedColumns(menuItems)

  // After paint, measure rendered card heights and rebalance into the shortest
  // column. Converges in two passes (heights are width-stable across columns).
  useLayoutEffect(() => {
    if (!menuItems?.length) {
      if (flatColumns.length) setColumns([])
      return
    }
    const heights = Array.from({ length: COLUMN_COUNT }, () => 0)
    const balanced = Array.from({ length: COLUMN_COUNT }, () => [])
    menuItems.forEach((cat) => {
      const el = cardRefs.current[cat.food_category_id]
      const h = (el?.getBoundingClientRect().height || 0) + COLUMN_GAP
      const target = heights.indexOf(Math.min(...heights))
      balanced[target].push(cat)
      heights[target] += h
    })
    const signature = (cols) =>
      cols.map((col) => col.map((c) => c.food_category_id).join(",")).join("|")
    if (signature(balanced) !== signature(columns)) setColumns(balanced)
  }, [menuItems, columns])

  // Card heights depend on viewport width — re-measure (re-seed) on resize.
  useEffect(() => {
    let timer
    const onResize = () => {
      clearTimeout(timer)
      timer = setTimeout(() => setColumns([]), 150)
    }
    window.addEventListener("resize", onResize)
    return () => {
      clearTimeout(timer)
      window.removeEventListener("resize", onResize)
    }
  }, [])

  const handleSearchField = (e) => {
    setSearchValue(e.target.value)
  }

  // Reorder within a category or move an item across categories. Updates local
  // state optimistically for an instant response, then persists. On failure the
  // saga re-fetches to revert to the authoritative server order.
  const handleDragEnd = (result) => {
    const { source, destination, draggableId } = result
    if (!destination) return
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return
    }

    // Apply the move to a fresh copy synchronously so we can both update state
    // and read the resulting order for the API payload.
    const next = menuItems.map((cat) => ({ ...cat, food_list: [...(cat?.food_list || [])] }))
    const from = next.find((c) => String(c.food_category_id) === source.droppableId)
    const to = next.find((c) => String(c.food_category_id) === destination.droppableId)
    if (!from || !to) return
    const [moved] = from.food_list.splice(source.index, 1)
    if (!moved) return
    to.food_list.splice(destination.index, 0, moved)
    setMenuItems(next)

    // meal_period is the model switch. Food meal-periods fall into the API's
    // "anything else" → FoodItem case, so linkCategory.item is correct here.
    // (Bar/Wine would need the exact "Bar Menu"/"Wine By Glass"/"Wine By Bottle"
    // strings if drag-and-drop is ever extended to them.)
    if (source.droppableId === destination.droppableId) {
      // Within a category → item-order endpoint with the full reordered list.
      dispatch(
        reorderMenuItemsAction({
          payload: {
            meal_period: linkCategory?.item,
            category_id: destination.droppableId,
            item_orders: to.food_list.map((it) => ({ id: it.id }))
          }
        })
      )
    } else {
      // Across categories → move-category endpoint. target_order is 1-based;
      // react-beautiful-dnd's destination.index is 0-based.
      dispatch(
        moveFoodItemCategoryAction({
          payload: {
            meal_period: linkCategory?.item,
            item_id: draggableId,
            target_category_id: destination.droppableId,
            target_order: destination.index + 1
          }
        })
      )
    }
  }

  // Generic drag-end for bar/wine lists (food has its own handler above). Same
  // optimistic-then-persist logic, parameterized by the items state, its setter,
  // and the API meal_period string for that list.
  const makeListDragEndHandler = (items, setItems, mealPeriod) => (result) => {
    const { source, destination, draggableId } = result
    if (!destination) return
    if (source.droppableId === destination.droppableId && source.index === destination.index) {
      return
    }
    const next = items.map((cat) => ({ ...cat, food_list: [...(cat?.food_list || [])] }))
    const from = next.find((c) => String(c.food_category_id) === source.droppableId)
    const to = next.find((c) => String(c.food_category_id) === destination.droppableId)
    if (!from || !to) return
    const [moved] = from.food_list.splice(source.index, 1)
    if (!moved) return
    to.food_list.splice(destination.index, 0, moved)
    setItems(next)

    if (source.droppableId === destination.droppableId) {
      dispatch(
        reorderMenuItemsAction({
          payload: {
            meal_period: mealPeriod,
            category_id: destination.droppableId,
            item_orders: to.food_list.map((it) => ({ id: it.id }))
          }
        })
      )
    } else {
      dispatch(
        moveFoodItemCategoryAction({
          payload: {
            meal_period: mealPeriod,
            item_id: draggableId,
            target_category_id: destination.droppableId,
            target_order: destination.index + 1
          }
        })
      )
    }
  }

  const getCurrentCategories = () => {
    if (linkCategory?.item === menuText.BARMENU) return barItems
    if (linkCategory?.item === menuText.WINEBAR || linkCategory?.item === menuText.WINEBOTTLE)
      return wineItems
    return menuItems
  }

  const handleCategoryReorderSave = (orderedCategories) => {
    const mealPeriod = MEAL_PERIOD_API[linkCategory?.item] || linkCategory?.item
    dispatch(
      reorderMenuCategoriesAction({
        payload: {
          meal_period: mealPeriod,
          category_orders: orderedCategories.map((c) => c.food_category_id)
        }
      })
    )
  }

  const handleRouting = () => {
    const itemsLink = {
      item: linkCategory?.item,
      category: menuSubCategory?.[0]?.name || "",
      list: "Summary View"
    }
    dispatch(marketingActions.setMenuLink(itemsLink))
    history.push("/marketing/dashboard/explore-menu")
  }

  function handleAddCategory(btnValue) {
    if (btnValue?.trim() === buttonText.CATEGORY) {
      setCategoryModal(true)
      setIsEditModal(false)
      setCurrentCategoryData(false)
      setIsEditModalItem(false)
      dispatch(marketingActions.setFoodItemsDetail({}))
    } else if (btnValue?.trim() === buttonText.ITEM) {
      setMenuItemsModal(true)
    } else {
      // setImportSpiritModal(true)
    }
  }

  function handleCloseMenuItems() {
    setMenuItemsModal(false)
    setIsEditModalItem(false)
    dispatch(marketingActions.setFoodItemsDetail({}))
  }

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Menu"
    return () => dispatch(marketingActions.setFoodItemsDetail({}))
  }, [])

  useEffect(() => {
    if (linkCategory?.item === menuText.BARMENU) {
      dispatch(getBarMenuPeriodAction())
    } else if (
      linkCategory?.item === menuText.WINEBAR ||
      linkCategory?.item === menuText.WINEBOTTLE
    ) {
      dispatch(getWineMenuPeriodAction())
    } else if (linkCategory?.item === menuText.SPIRITS) {
      dispatch(getSpiritCMSAction())
      dispatch(getNewSpiritCountAction())
    } else {
      dispatch(getMenuSubCategoryAction())
      dispatch(getMenuPeriodAction())
    }
    setSearchValue("")
    dispatch(getDynamicMenuFieldsAction({ category: toTitleCase(linkCategory?.item) }))
  }, [linkCategory?.item, linkCategory?.category, menuCategory])

  function filterResults(searchQuery, results, menuType) {
    const trimmedQuery = searchQuery.trim().toLowerCase()

    if (!trimmedQuery) {
      return results
    }

    const isSpiritsMenu = menuType === menuText.SPIRITS
    const listKey = isSpiritsMenu ? "spirit_list" : "food_list"
    const categoryKey = isSpiritsMenu ? "spirit_category" : "food_category"

    return results
      ?.map((period) => {
        const category = period[categoryKey]?.toLowerCase()
        const isCategoryMatch = category.includes(trimmedQuery)

        // If the search query partially matches the category, return all items in that category
        if (isCategoryMatch) {
          return period
        }

        // Filter items by name or by ingredients
        const filteredList = period[listKey]?.filter((item) => {
          const nameMatch = item?.name?.toLowerCase().includes(trimmedQuery)

          const ingredientsField = item?.data_to_display?.find(
            (field) => field.filedName === "Ingredients" || field.filedName === "Ingredient"
          )
          let ingredientMatch
          if (isSpiritsMenu) {
            ingredientMatch = item?.ingredient?.some((ingredient) =>
              ingredient?.name?.toLowerCase().includes(trimmedQuery)
            )
          } else {
            ingredientMatch = Array.isArray(ingredientsField?.value)
              ? ingredientsField.value.some((ingredient) =>
                  ingredient.name.toLowerCase().includes(trimmedQuery)
                )
              : ingredientsField?.value.toLowerCase().includes(trimmedQuery)
          }

          return nameMatch || ingredientMatch
        })

        return filteredList?.length > 0 ? { ...period, [listKey]: filteredList } : null
      })
      .filter(Boolean)
      .sort((a, b) => {
        const categoryA = a[categoryKey].toLowerCase()
        const categoryB = b[categoryKey].toLowerCase()

        // Sort based on how closely the category matches the query
        if (categoryA === trimmedQuery) return -1
        if (categoryB === trimmedQuery) return 1

        if (categoryA.startsWith(trimmedQuery) && !categoryB.startsWith(trimmedQuery)) return -1
        if (!categoryA.startsWith(trimmedQuery) && categoryB.startsWith(trimmedQuery)) return 1

        return categoryA.localeCompare(categoryB)
      })
  }

  useEffect(() => {
    const menuMap = {
      [menuText.BARMENU]: {
        data: barMenuPeriod,
        setFunction: setBarItems
      },
      [menuText.WINEBAR]: {
        data: wineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.WINEBOTTLE]: {
        data: wineMenuPeriod,
        setFunction: setWineItems
      },
      [menuText.SPIRITS]: {
        data: spiritData,
        setFunction: setSpiritItems
      },
      default: {
        data: menuPeriod,
        setFunction: setMenuItems
      }
    }

    const { data, setFunction } = menuMap[linkCategory?.item] || menuMap.default
    const filteredResults = filterResults(debouncedSearchTerm, data, linkCategory?.item)
    setFunction(filteredResults)
  }, [
    barMenuPeriod,
    wineMenuPeriod,
    spiritData,
    menuPeriod,
    linkCategory?.item,
    menuCategory?.name,
    linkCategory?.category,
    debouncedSearchTerm
  ])

  return (
    <Fragment>
      {/* {importSpiritModal && <ImportSpiritsModal onClose={() => setImportSpiritModal(false)} />} */}
      {<MobilePreview open={openPreviewModal} handleClose={() => setOpenPreviewModal(false)} />}
      {linkCategory?.item === menuText?.SPIRITS ? (
        <DMVAddMenuItems
          isEdit={isEditModalItem}
          open={menuItemsModal}
          onClose={handleCloseMenuItems}
          isCMS={true}></DMVAddMenuItems>
      ) : (
        <AddMenuItems
          isEdit={isEditModalItem}
          open={menuItemsModal}
          onClose={handleCloseMenuItems}
        />
      )}
      {linkCategory?.item !== menuText.BARMENU &&
        linkCategory?.item !== menuText.SPIRITS &&
        linkCategory?.item !== menuText.WINEBAR &&
        linkCategory?.item !== menuText.WINEBOTTLE && (
          <CategoryModal
            data={currentCategoryData}
            isEdit={isEditModal}
            open={categoryModal}
            setMenuItemsModal={setMenuItemsModal}
            onClose={setCategoryModal}></CategoryModal>
        )}
      {linkCategory?.item === menuText.BARMENU && (
        <BarMenuCategoryModal
          data={currentCategoryData}
          isEdit={isEditModal}
          open={categoryModal}
          setMenuItemsModal={setMenuItemsModal}
          onClose={setCategoryModal}></BarMenuCategoryModal>
      )}
      {linkCategory?.item === menuText.WINEBAR && (
        <WineCategoryModal
          data={currentCategoryData}
          isEdit={isEditModal}
          open={categoryModal}
          setMenuItemsModal={setMenuItemsModal}
          label="Wine"
          onClose={setCategoryModal}
        />
      )}
      {linkCategory?.item === menuText.WINEBOTTLE && (
        <WineCategoryModal
          data={currentCategoryData}
          isEdit={isEditModal}
          open={categoryModal}
          setMenuItemsModal={setMenuItemsModal}
          label="Wine By Bottle"
          onClose={setCategoryModal}
        />
      )}
      <Container fluid className="p-0">
        <Row>
          <Col lg="12">
            <Header title={`Menu`} breadCrumbs={breadCrumbs}>
              <div className="d-flex align-items-center gap-2">
                {linkCategory?.item !== menuText.SPIRITS && (
                  <AppButton variant="contained" onClick={() => setReorderCategoriesOpen(true)}>
                    Reorder Categories
                  </AppButton>
                )}
                <AppButton
                  styles={{
                    backgroundColor: theme.palette.background.main,
                    padding: "12px 25px"
                  }}
                  variant="filled"
                  onClick={handleRouting}>
                  Done
                </AppButton>
              </div>
            </Header>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col lg="12">
            <MenuNavBar
              isEdit={isEdit}
              activeTab={linkCategory?.item}
              subCategory={menuSubCategory?.[0]?.name}></MenuNavBar>
          </Col>
        </Row>
        {(linkCategory?.item === menuText.DINNER ||
          linkCategory?.item === menuText.LUNCH ||
          linkCategory?.item === menuText.BRUNCH ||
          linkCategory?.item === menuText.BREAKFAST ||
          linkCategory?.item === menuText.SPECIALS) && (
          <Row className="mt-4">
            <Col lg="12">
              <SubMenuBar
                isEdit={isEdit}
                activeTab={linkCategory?.category}
                menu={menuSubCategory}></SubMenuBar>
            </Col>
          </Row>
        )}
        {linkCategory?.item === menuText.SPIRITS && (
          <Row className="mt-4">
            <Col lg={12}>
              <SpiritsSubMenuBar isCMS={true} activeTab={menuCategory?.name} isEdit={true} />
            </Col>
          </Row>
        )}
      </Container>
      <Container fluid className="p-0">
        <Row className="m-0 mt-2 mb-4 pb-2" style={{ borderBottom: "1px solid gray" }}>
          <Col lg="12" className="p-0 d-flex justify-content-between align-items-center">
            <Typography variant="h2">
              {linkCategory?.item === menuText.DINNER ||
              linkCategory?.item === menuText.LUNCH ||
              linkCategory?.item === menuText.BRUNCH ||
              linkCategory?.item === menuText.BREAKFAST
                ? linkCategory?.category
                : ""}
            </Typography>
            {linkCategory?.item !== menuText.SPIRITS && (
              <Grid sx={{ position: "relative" }}>
                <AppButton
                  onClick={(e) => handleAddCategory(e.target.innerText)}
                  styles={{
                    backgroundColor: theme.palette.background.main,
                    padding: "10px 20px"
                  }}>
                  {linkCategory?.item === menuText.DINNER ||
                  linkCategory?.item === menuText.LUNCH ||
                  linkCategory?.item === menuText.BRUNCH ||
                  linkCategory?.item === menuText.BREAKFAST ||
                  linkCategory?.item === menuText.SPECIALS ||
                  linkCategory?.item === menuText.BARMENU ||
                  linkCategory?.item === menuText.WINEBAR ||
                  linkCategory?.item === menuText.WINEBOTTLE
                    ? buttonText.CATEGORY
                    : linkCategory?.item === menuText.SPIRITS
                    ? buttonText.IMPORT_SPIRITS
                    : buttonText.CATEGORY}
                </AppButton>
                {/* {linkCategory?.item === menuText.SPIRITS && newSpiritCount?.[0]?.total_amount && (
                <Grid item className={classes.ellipse_gold}>
                  {newSpiritCount?.[0]?.total_amount}
                </Grid>
              )} */}
              </Grid>
            )}
          </Col>
        </Row>
        <Row className={"mb-2"}>
          <Col lg="4">
            <SearchTextField
              id="search"
              name="search"
              value={searchValue}
              onChange={handleSearchField}
              fullWidth
              type="search"
              placeholder="Search menu items or ingredients"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{
                      backgroundColor: theme.palette.primary.main
                    }}>
                    <SearchIcon htmlColor={`${theme.palette.text.secondary}`} />
                  </InputAdornment>
                )
              }}
              style={{
                border: `1px solid ${theme.palette.text.secondary}`,
                backgroundColor: theme.palette.primary.main,
                borderRadius: 6
              }}
            />
          </Col>
        </Row>
        {linkCategory?.item !== menuText.BARMENU &&
          linkCategory?.item !== menuText.SPIRITS &&
          linkCategory?.item !== menuText.WINEBOTTLE &&
          linkCategory?.item !== menuText.WINEBAR &&
          (menuItems?.length > 0 ? (
            // Two real flex columns with shortest-column balancing — gives the
            // tight Masonry-style packing (no inter-row gaps) while keeping cards
            // in normal document flow so react-beautiful-dnd works.
            <DragDropContext onDragEnd={handleDragEnd}>
              <div style={{ display: "flex", gap: COLUMN_GAP, alignItems: "flex-start" }}>
                {displayColumns.map((column, columnIndex) => (
                  <div
                    key={columnIndex}
                    style={{
                      flex: 1,
                      minWidth: 0,
                      display: "flex",
                      flexDirection: "column",
                      gap: COLUMN_GAP
                    }}>
                    {column.map((menuItem) => (
                      <div
                        key={menuItem.food_category_id}
                        ref={(el) => (cardRefs.current[menuItem.food_category_id] = el)}>
                        <MenuListContainer
                          setMenuItemsModal={setMenuItemsModal}
                          setCurrentCategoryData={setCurrentCategoryData}
                          setIsEdit={setIsEditModal}
                          setIsEditModalItem={setIsEditModalItem}
                          setCategoryModal={setCategoryModal}
                          setOpenPreviewModal={setOpenPreviewModal}
                          isEdit={isEdit}
                          droppableId={String(menuItem.food_category_id)}
                          dragEnabled={!searchValue && !debouncedSearchTerm}
                          data={menuItem}
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </DragDropContext>
          ) : (
            <Typography>
              {searchValue ? "No items found matching your search" : "No Data Found"}
            </Typography>
          ))}
        {linkCategory?.item === menuText.BARMENU &&
          (barItems?.length > 0 ? (
            <MenuDndBoard
              items={barItems}
              getId={(c) => c.food_category_id}
              onDragEnd={makeListDragEndHandler(
                barItems,
                setBarItems,
                MEAL_PERIOD_API[menuText.BARMENU]
              )}
              renderCard={(menuItem) => (
                <BarListItems
                  isEdit={isEdit}
                  data={menuItem}
                  droppableId={String(menuItem.food_category_id)}
                  dragEnabled={!searchValue && !debouncedSearchTerm}
                  setMenuItemsModal={setMenuItemsModal}
                  setCurrentCategoryData={setCurrentCategoryData}
                  setIsEdit={setIsEditModal}
                  setIsEditModalItem={setIsEditModalItem}
                  setCategoryModal={setCategoryModal}
                  setOpenPreviewModal={setOpenPreviewModal}
                />
              )}
            />
          ) : (
            <Typography>
              {searchValue ? "No items found matching your search" : "No Data Found"}
            </Typography>
          ))}
        {linkCategory?.item === menuText.WINEBAR &&
          (wineItems?.length > 0 ? (
            <MenuDndBoard
              items={wineItems}
              getId={(c) => c.food_category_id}
              onDragEnd={makeListDragEndHandler(
                wineItems,
                setWineItems,
                MEAL_PERIOD_API[menuText.WINEBAR]
              )}
              renderCard={(menuItem) => (
                <WineListItems
                  isEdit={isEdit}
                  data={menuItem}
                  droppableId={String(menuItem.food_category_id)}
                  dragEnabled={!searchValue && !debouncedSearchTerm}
                  setCurrentCategoryData={setCurrentCategoryData}
                  setIsEdit={setIsEditModal}
                  setCategoryModal={setCategoryModal}
                  setOpenPreviewModal={setOpenPreviewModal}
                />
              )}
            />
          ) : (
            <Typography>
              {searchValue ? "No items found matching your search" : "No Data Found"}
            </Typography>
          ))}
        {linkCategory?.item === menuText.WINEBOTTLE &&
          (wineItems?.length > 0 ? (
            <MenuDndBoard
              items={wineItems}
              getId={(c) => c.food_category_id}
              onDragEnd={makeListDragEndHandler(
                wineItems,
                setWineItems,
                MEAL_PERIOD_API[menuText.WINEBOTTLE]
              )}
              renderCard={(menuItem) => (
                <WineBottleListItems
                  isEdit={isEdit}
                  data={menuItem}
                  droppableId={String(menuItem.food_category_id)}
                  dragEnabled={!searchValue && !debouncedSearchTerm}
                  setCurrentCategoryData={setCurrentCategoryData}
                  setIsEdit={setIsEditModal}
                  setCategoryModal={setCategoryModal}
                  setOpenPreviewModal={setOpenPreviewModal}
                />
              )}
            />
          ) : (
            <Typography>
              {searchValue ? "No items found matching your search" : "No Data Found"}
            </Typography>
          ))}
        {linkCategory?.item === menuText.SPIRITS && (
          <>
            <Grid item sx={{ maxWidth: "50%" }}>
              {SpiritSubMenu?.map(
                (foodList, i) =>
                  foodList?.id === menuCategory?.name &&
                  (foodList?.description ||
                    foodList?.image_url ||
                    foodList?.unique_facts?.length > 0) && (
                    <DMV_SpiritSummary key={i} isEdit={false} foodList={foodList} isCMS={true} />
                  )
              )}
            </Grid>
            <Container fluid className="p-0 mt-4">
              <div className={classes.spiritContainer}>
                {spiritItems?.length > 0 ? (
                  spiritItems?.map((menuItem, idx) => {
                    return (
                      <SpiritsMenuListContainer
                        setMenuItemsModal={setMenuItemsModal}
                        setCurrentCategoryData={setCurrentCategoryData}
                        setIsEdit={setIsEditModal}
                        setIsEditModalItem={setIsEditModalItem}
                        setCategoryModal={setCategoryModal}
                        isEdit={isEdit}
                        data={menuItem}
                        key={idx}
                      />
                    )
                  })
                ) : (
                  <Typography>
                    {searchValue ? "No items found matching your search" : "No Data Found"}
                  </Typography>
                )}
              </div>
            </Container>
          </>
        )}
      </Container>
      <ReorderCategoriesModal
        open={reorderCategoriesOpen}
        onClose={() => setReorderCategoriesOpen(false)}
        categories={getCurrentCategories()}
        onSave={handleCategoryReorderSave}
      />
    </Fragment>
  )
}

export default EditMenu
